import React, { useEffect, useState, useRef } from "react";
import { hash, event } from "../Utils";
import classnames from "classnames";
import SVG from "react-inlinesvg";
import { CardViewHeader, CardViewOptions, DeleteButton } from "./styles";
import InlineSVG from "react-inlinesvg";
import ConfirmModal from "../components/ConfirmModal";
import useClickedOutside from "../hooks/useClickedOutside";
import { createPortal } from "react-dom";
import { usePopper } from "react-popper";


// parses image url
export function parseContent(content) {
  const re = /{{\s*?image_url:\s*"(.*?)"\s*}}/;
  const c = content.replace(re, (match, url) => {
    return [`<img src='${url}' />`];
  });

  const matches = content.match(re);

  let url = null;
  if (matches && matches[1]) {
    url = matches[1];
  }

  return [c, url];
}


// A single card in a card set
const ImageCardView = React.memo(function ImageCardView(props) {
  let showFav = !props.disableFav;
  let showLikes = !props.disableLikes;

  // checks in the favoritesbycards hash whether this completion has been faved

  let faved = false;
  if (props.favoritesByCards[props.card.id]) {
    faved = props.favoritesByCards[props.card.id][hash(props.content)];
  }

  const [content, url] = parseContent(props.content);

  // Liking logic
  const [liking, setLiking] = useState(false);
  const [wiggle, setWiggle] = useState(false);
  let liked = props.card.hasLiked([props.pathKey, props.pathIndex]);

  // prevents liking multiple times while requests in flight
  let ifNotLiking = (wiggle, callback) => {
    if (!liking) {
      setLiking(true);

      if (wiggle) {
        // Wiggle animation
        setWiggle(true);
        setTimeout(() => {
          setWiggle(false);
        }, 1000);
      }

      callback().then(() => {
        setLiking(false);
      });
    }
  };

  // Copying
  const [copied, setCopied] = useState(false);


  const [isOptionsOpen, setIsOptionsOpen] = useState(false);

  const handleToggleOptions = () => setIsOptionsOpen(prev => !prev);
  const handleCloseOptions = () => setIsOptionsOpen(false);

  const optionsContainerRef = useClickedOutside(handleCloseOptions);

  useEffect(() => {
    if (!isOptionsOpen) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") handleCloseOptions();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isOptionsOpen]);

  const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] = useState(false);

  const handleDeleteItem = async () => {
    setIsConfirmDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    props.onDeleteCardItem();
    setIsConfirmDeleteModalOpen(false);
  };

  const handleDeleteCancel = () => {
    setIsConfirmDeleteModalOpen(false);
  };

  const [confirmModal, setConfirmModal] = useState(null);
  const containerRef = useRef(null);
  const {
    styles: modalStyles,
    attributes: modalAttributes,
  } = usePopper(
    containerRef.current,
    confirmModal,
    {
      placement: 'top',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 10],
          },
        },
      ],
    }
  );

  const confirmModalClickOutsideRef = useClickedOutside(handleDeleteCancel);

  return (
    <div
      onCopy={(e) => {
        const selection = document.getSelection();
        const selectedText = selection?.toString() || "";
        if (selectedText.length > 0) {
          // event for copies
          event({
            eventType: "select-copy",
            cardId: props.card.id,
            path: [props.pathKey, props.pathIndex],
          });
        }
      }}
      className={classnames({
        card: true,
        border: props.border,
        wiggle: wiggle,
      })}
    >
      <CardViewHeader ref={containerRef}>
        <span className="title">{props.title ? props.title : ''}</span>
        <CardViewOptions ref={optionsContainerRef}>
          <div onMouseDown={(e) => e.stopPropagation()} onClick={handleToggleOptions} className="trigger">
            <InlineSVG
              src="/assets/hotdog-menu.svg"
              height={20}
              width={20}
            />
          </div>
          {
            isOptionsOpen && (
              <div onClick={handleCloseOptions} className="options">
                <DeleteButton
                  src="/assets/delete.svg"
                  onClick={handleDeleteItem}
                >Delete</DeleteButton>
              </div>
            )
          }
        </CardViewOptions>
      </CardViewHeader>

      <div dangerouslySetInnerHTML={{ __html: content }}></div>

      {!props.hideDivider && <div className="divider-line"></div>}

      <div className={classnames({ extra_bottom: props.hideDivider, bottom_menu: true })}>

        <a
          className={classnames({
            insert: true,
            highlight: props.highlightInsert,
          })}
          href="#"
          onClick={(e) => {
            e.preventDefault();
            console.log(props.content);
            props.insertEditor({ image: url });
            event({
              eventType: "insert",
              cardId: props.card.id,
              path: [props.pathKey, props.pathIndex],
            });
          }}
        >
          <SVG src="/assets/arrow.backward.circle.svg" />
          <span>Insert</span>
        </a>

        <a className="insert" href={url} target="_blank" download onClick={async e => {
          e.preventDefault();

          event({
            eventType: "save",
            cardId: props.card.id,
            path: [props.pathKey, props.pathIndex],
          });

          window.open(url);
        }}>
          Save
        </a>

        {/* {!props.card.data.demo && (
          <CopyToClipboard
            text={props.content}
            onCopy={() => {
              setCopied(true);
              setTimeout(() => {
                setCopied(false);
              }, 1000);
              event({
                eventType: "copy",
                cardId: props.card.id,
                path: [props.pathKey, props.pathIndex],
              });
            }}
          >
            <a className="copy">
              <SVG src="/assets/docondoc.svg" />
              <span>{copied ? "Copied" : "Copy"}</span>
            </a>
          </CopyToClipboard>
        )} */}

        {!props.card.data.demo && props.doneStreaming && (
          <div className="card-action-menu">
            {showLikes && (
              <>
                {/* thumbs down */}
                {liked === -1 && (
                  <a
                    href="#"
                    className="like"
                    onClick={(e) => {
                      e.preventDefault();
                      ifNotLiking(false, () => {
                        return props.card.removeLike([props.pathKey, props.pathIndex]);
                      });
                    }}
                  >
                    <SVG src="/assets/thumbsdown-filled.svg" />
                  </a>
                )}

                {(liked === null || liked === 1) && (
                  <a
                    href="#"
                    className="like"
                    onClick={(e) => {
                      e.preventDefault();
                      ifNotLiking(true, () => {
                        return props.card.createLike([props.pathKey, props.pathIndex], -1);
                      });
                    }}
                  >
                    <SVG src="/assets/thumbsdown.svg" />
                  </a>
                )}

                {/* thumbs up*/}
                {liked === 1 && (
                  <a
                    href="#"
                    className="like on"
                    onClick={(e) => {
                      e.preventDefault();
                      ifNotLiking(false, () => {
                        return props.card.removeLike([props.pathKey, props.pathIndex]);
                      });
                    }}
                  >
                    <SVG src="/assets/thumbsup-filled.svg" />
                  </a>
                )}

                {(liked === null || liked === -1) && (
                  <a
                    href="#"
                    className="like"
                    onClick={(e) => {
                      e.preventDefault();
                      ifNotLiking(false, () => {
                        return props.card.createLike([props.pathKey, props.pathIndex], 1);
                      });
                    }}
                  >
                    <SVG src="/assets/thumbsup.svg" />
                  </a>
                )}
              </>
            )}
            {/* star */}
            {showFav && (
              <>
                {!faved && (
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      props.onFavorite(props.card, props.content);
                      event({
                        eventType: "favorite",
                        cardId: props.card.id,
                        path: [props.pathKey, props.pathIndex],
                      });
                    }}
                    className="favourite"
                  >
                    <SVG src="/assets/star.svg" />
                  </a>
                )}

                {faved && (
                  <a
                    href="#"
                    className="faved"
                    alt="Unfavorite"
                    onClick={(e) => {
                      e.preventDefault();
                      props.onUnfavorite(props.card, props.content);
                    }}
                  >
                    <SVG src="/assets/star.fill.svg" />
                  </a>
                )}
              </>
            )}
          </div>
        )}
      </div>

      <div className="clearfix"></div>
      {
        isConfirmDeleteModalOpen && createPortal(
          <ConfirmModal
            ref={(node) => {
              setConfirmModal(node);
              confirmModalClickOutsideRef.current = node;
            }} style={modalStyles.popper} {...modalAttributes.popper}
            content="This card will be deleted permanently."
            onCancel={handleDeleteCancel}
            onConfirm={handleDeleteConfirm}
          />,
          document.getElementById('card-sets'),
        )
      }
    </div>
  );
});

export default ImageCardView;
